export default __webpack_public_path__ + "static/media/device-previews.e4012f24.png";